/** Shared label for product search Autocomplete options (API shape may vary). */
export const getSearchOptionLabel = (option) => {
  if (!option?.params) return "";
  const p = option.params;
  const desc = p.Description ?? p.description ?? "";
  const code = p.ItemCode ?? p.itemCode ?? "";
  return `${desc} (${code})`.trim();
};
